import { MessageCircleMore, Plus } from "lucide-react";
import { Button } from "@ui";

interface ChatHeaderProps {
  title: string;
  onOpenHistory: () => void;
  onNewConversation: () => void;
  canCreateNew: boolean;
}

export function ChatHeader({
  title,
  onOpenHistory,
  onNewConversation,
  canCreateNew,
}: ChatHeaderProps) {
  return (
    <div className="w-full flex-shrink-0 border-b border-slate-200 bg-white h-[60px]">
      <div className="pageInset h-full items-center justify-between">
        <h1 className="text-xl font-semibold text-slate-800 truncate">
          {title}
        </h1>
        <div className="flex items-center gap-2">
          {canCreateNew && (
            <Button
              variant="primary"
              size="sm"
              icon={Plus}
              onClick={onNewConversation}
            >
              Nouvelle recherche
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            icon={MessageCircleMore}
            onClick={onOpenHistory}
            className="!bg-default-50 !text-default-600 hover:!bg-default-100"
          >
            Historique
          </Button>
        </div>
      </div>
    </div>
  );
}
